/* eslint-disable no-console */
/* eslint-disable max-len */
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import React, { useState, useContext, useRef, useMemo, useEffect } from 'react';
import { MdOutlineCelebration, MdOutlineCancel } from 'react-icons/md';

import ScheduleLaterPopup from './Components/ScheduleLaterPopup';
import UrlPopup from './Components/UrlPopup';
import Occasion from '../../Occassion';
import AddPoll from '../../AddPoll';
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react';
import { AiOutlineYoutube } from 'react-icons/ai';
import { BsLink, BsEmojiLaughing } from 'react-icons/bs';
import { IoTimeOutline, IoDocumentTextOutline } from 'react-icons/io5';

import AddEmployeeHeader from '../../../../../../BusinessSettings/Components/Meetings/ManagementMeetings/Components/ManageHosts/Components/AddHosts/AddHostsHeader';
import { createFeedContext } from '..';
import FeedAttachments from './FeedAttachments';
import { useSelector } from 'react-redux';
import useGetFeedPermissions from '../../../../CustomHooks/useGetFeedPermissions';
import { LanguageContext } from '../../../../../../../libs/Context';
import { add } from 'date-fns';

const FooterActions = (props:any) =>
{
	const { handlePollData, requestT, externalFile, setFooterAction, footerAction } = props;
	const { createFeed, setCreateFeed } = useContext(createFeedContext);
	const emojiPickerRef = useRef<HTMLDivElement>(null);
	const { language } = useContext(LanguageContext);

	// Constant for action configurations to reduce component complexity
	const ACTION_CONFIGS = {
		// document  : { icon: IoDocumentTextOutline, fontSize: 'var(--pixel20)', tooltip: language.document },
		link      : { icon: BsLink, fontSize: 'var(--pixel24)', tooltip: language.link },
		youtube   : { icon: AiOutlineYoutube, fontSize: 'var(--pixel20)', tooltip: language.youtubeUrl },
		// schedule  : { icon: IoDocumentTextOutline, fontSize: 'var(--pixel20)', tooltip: language.scheduleLater },
		emoji     : { icon: BsEmojiLaughing, fontSize: 'var(--pixel18)', tooltip: language.emoji },
		occasion  : { icon: MdOutlineCelebration, fontSize: 'var(--pixel20)', tooltip: language.createOccasion },
		poll      : { icon: '/images/icons/pollsFeed.svg', tooltip: language.createPoll, fontSize: '' },
		tagPeople : { icon: '/images/icons/taggedicon.svg', tooltip: language.tagPeople, fontSize: '' },
		schedule  : { icon: IoTimeOutline, tooltip: language.scheduleLater, fontSize: 'var(--pixel20)' }
	};

	useEffect(() =>
	{
		const handleClickOutside = (event) =>
		{
			if (footerAction === 'emoji' &&
                emojiPickerRef.current &&
                !emojiPickerRef.current.contains(event.target))
			{
				setFooterAction(null);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () =>
		{
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ footerAction, setFooterAction ]);
	// const [ footerAction, setFooterAction ] = useState<any>(requestT === 'driveUpload' ? 'image' : null);
	const [ taggedPeople, setTaggedPeople ] = useState<any>({
		selectEmp   : false,
		selectEvent : '',
		addedUser   : []
	});

	const { selectEmp, selectEvent, addedUser } = taggedPeople;
	const alrdyAddedTagPeopleRef = useRef(createFeed?.taggedPeople || []);

	// Memoized derived states
	const feedState = useMemo(() => ({
		isPollCreated      : createFeed?.poll && Object.keys(createFeed?.poll)?.length > 0,
		isOccasionCreated  : createFeed?.occasion && Object.keys(createFeed?.occasion)?.length > 0,
		isMediaCreated     : createFeed?.media && createFeed?.media?.length > 0,
		arePeopleTagged    : createFeed?.taggedPeople && createFeed?.taggedPeople?.length > 0,
		isYoutubeAdded     : createFeed?.media?.some((item:any) => item?.type === 'youtube'),
		isDescriptionAdded : (() =>
		{
			const parser = new DOMParser();
			const doc = parser.parseFromString(createFeed?.description ?? '', 'text/html');

			return Boolean(doc.body.textContent);
		})()
	}), [ createFeed?.poll,
		createFeed?.occasion,
		createFeed?.media,
		createFeed?.taggedPeople,
		createFeed?.media,
		createFeed?.description
	]);

	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions('', userData);

	// Permissions and restrictions
	const permissions = useMemo(() => ({
		hasSchedulePermission : getPermission('schedulePost'),
		hasOccasionPermission : getPermission('occasions'),
		hasPollPermission     : getPermission('polls')
	}), [ getPermission ]);

	// Memoized action restrictions
	const actionRestrictions = useMemo(() =>
	{
		const { isPollCreated, isOccasionCreated, isMediaCreated, arePeopleTagged, isYoutubeAdded, isDescriptionAdded } = feedState;
		const isReposting = requestT === 'repost';

		return {
			link : {
				hide     : isPollCreated || isOccasionCreated,
				disabled : isYoutubeAdded || isPollCreated || isOccasionCreated || isReposting
			},
			youtube : {
				hide     : isPollCreated || isOccasionCreated,
				disabled : (isMediaCreated && !isYoutubeAdded) || isPollCreated || isOccasionCreated || isReposting
			},
			schedule : {
				hide     : !permissions.hasSchedulePermission,
				disabled : requestT === 'editFeeds'
			},
			emoji : {
				hide     : isPollCreated,
				disabled : isPollCreated
			},
			occasion : {
				hide     : !permissions.hasOccasionPermission || isPollCreated || isOccasionCreated,
				disabled : isMediaCreated || arePeopleTagged || isPollCreated || isReposting || requestT === 'editFeeds'
			},
			poll : {
				hide     : !permissions.hasPollPermission || isPollCreated || isOccasionCreated,
				disabled : isMediaCreated || arePeopleTagged || isOccasionCreated || isReposting || requestT === 'editFeeds'
			},
			tagPeople : {
				hide       : isPollCreated || isOccasionCreated || userData?.role === 'individual',
				disabled   : isPollCreated || isOccasionCreated || isReposting,
				removeIcon : userData?.role === 'individual'
			}
		};
	}, [ feedState, permissions, requestT ]);

	const handleOpenEmplist = (eType) => (
		setTaggedPeople((prev) => ({ ...prev, selectEmp: true, selectEvent: eType }))
	);

	// Handlers for TagPeople-Action
	const updateTagPeople = (obj:any) =>
	{
		setTaggedPeople((prev:any) => ({
			...prev,
			addedUser   : obj?.employees,
			selectEvent : 'tagpeople',
			selectEmp   : false
		}));
		alrdyAddedTagPeopleRef.current = obj?.employees ?? addedUser;
		setCreateFeed((prev) => ({
			...prev,
			taggedPeople : obj?.employees
		}));
	};

	useEffect(() =>
	{
		updateTagPeople({ employees: createFeed?.taggedPeople });
	}, [ createFeed?.taggedPeople ]);

	// Footer action handler
	const handleFooterActions = (action) =>
	{
		const { isPollCreated, isOccasionCreated } = feedState;

		if ((([ 'link', 'youtube', 'tagPeople' ].includes(action) && (isPollCreated || isOccasionCreated)) ||
			([ 'poll' ].includes(action) && (feedState.isMediaCreated || feedState.arePeopleTagged)))) return;

		action === 'tagPeople'
			? handleOpenEmplist('tagPeople')
			: setFooterAction(footerAction === action ? null : action);
	};

	const handleDescriptionCheck = (obj) =>
	{
		if (obj?.description && obj?.description !== '')
		{
			return obj?.description;
		}
		else
		{
			return '<p></p>';
		}
	};

	const handleEmojiSelect = (e) =>
	{
		setCreateFeed((prev) =>
		{
			const isOccasionValid = prev?.occasion && Object.keys(prev.occasion).length > 0;
			const newText = isOccasionValid
				? (prev.occasion.text ?? '') + e.emoji
				: (handleDescriptionCheck(prev)).replace(/<p>[^<]*<\/p>(?!.*<p>)/, (match) => match.replace(/<\/p>/, `${e.emoji}</p>`));

			return {
				...prev,
				...(isOccasionValid
					? { occasion: { ...prev.occasion, text: newText } }
					: { description: newText })
			};
		});
	};

	const renderActions = () =>
	{
		return Object.entries(ACTION_CONFIGS).map(([ key, config ]) =>
		{
			const { hide, disabled, removeIcon = '' } = actionRestrictions[key] || {};

			// if (hide) return null;

			const checkTagPeopleFrIndividual = key === 'tagPeople' && removeIcon;

			if (checkTagPeopleFrIndividual)
			{
				return null;
			}

			const Icon = config.icon;

			return (
				<Tooltip key={key} title={config.tooltip} placement='top' arrow>
					<Box display={'flex'} alignItems={'center'}
						sx={{
							width  : `${typeof Icon === 'string' ? 'var(--pixel18)' : 'auto'}`,
							height : `${typeof Icon === 'string' ? 'var(--pixel18)' : 'auto'}`,
							cursor : 'pointer',
							color  : 'inherit'
						}}
						style={(disabled || hide) ? { pointerEvents: 'none', opacity: 0.5 } : {}}
					>
						{typeof Icon === 'string'
							? (
								<img
									src={Icon}
									alt={config.tooltip}
									onClick={() => handleFooterActions(key === 'poll' ? 'poll' : 'tagPeople')}
									style={{ width: 'var(--percent100)', height: 'var(--percent100)', filter: 'none' }}
								/>
							)
							: (
								<Icon
									fontSize={config.fontSize}
									onClick={() => handleFooterActions(key)}
									color='inherit'
								/>
							)}
					</Box>
				</Tooltip>
			);
		})
			.filter(Boolean);
	};

	return (
		<>
			<Stack direction={'row'} spacing={3} alignItems={'center'}>
				{/* Files,Image, and Video */}
				{!feedState?.isPollCreated && !feedState?.isOccasionCreated && (
					<FeedAttachments requestT={requestT} externalFile={externalFile} />
				)}
				{renderActions()}
				{footerAction === 'emoji' && (
					<Box position='absolute' ref={emojiPickerRef} bottom={56} left={0} zIndex={999} overflow='auto' maxHeight='300px' width='92%'>
						<Box display='flex' justifyContent='flex-end' sx={{ cursor: 'pointer' }}>
							<IconButton size='small' onClick={() => setFooterAction(null)}>
								<MdOutlineCancel fontSize={18} />
							</IconButton>
						</Box>
						<EmojiPicker
							emojiStyle={EmojiStyle.GOOGLE}
							height={270}
							width='var(--percent100)'
							previewConfig={{ showPreview: false }}
							autoFocusSearch={false}
							onEmojiClick={handleEmojiSelect}
						/>
					</Box>
				)}
			</Stack>
			{/* All Feed-Footer Action... */}
			{/* Popups and Modals */}
			{footerAction === 'schedule' && (
				<ScheduleLaterPopup
					openPop
					handleClose={handleFooterActions}
				/>
			)}
			<Occasion
				handleClose={handleFooterActions}
				openOccasion={footerAction === 'occasion'}
			/>
			{footerAction === 'poll' && (
				<AddPoll
					pollOpen
					handlepollClose={handleFooterActions}
					handlePollData={handlePollData}
				/>
			)}

			{(selectEmp && selectEvent === 'tagPeople') &&
			<AddEmployeeHeader
				open={selectEmp}
				onClose={() => setTaggedPeople((prev) => ({ ...prev, selectEmp: false }))}
				alrdyAddedUsersref={alrdyAddedTagPeopleRef}
				updateTagPeople={updateTagPeople}
				from='newsFeed'
				feedType='tagPeople'
			/>
			}
			{[ 'link', 'youtube' ].includes(footerAction || '') && (
				<UrlPopup
					type={footerAction}
					open
					handleClose={handleFooterActions}
				/>
			)}
		</>
	);
};

export default FooterActions;
